import React from "react";
import { Link } from "react-router-dom";
import icon1 from "../../../images/icon/call-calling.svg";
import icon2 from "../../../images/icon/icon-sms.svg";
import icon3 from "../../../images/footer/google-play.png";
import icon4 from "../../../images/footer/app-store.png";
import iconwp from "../../../images/icon/Buga/wplogo.png";

import { NavLink } from "react-router-dom";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const SubmitHandler = (e) => {
  e.preventDefault();
};

const Footer = (props) => {
  return (
    <footer
      className="footer footer-style-two footer-style-four bg_img pos-rel"
      style={{ backgroundColor: "#16140c" }}
    >
      <div className="container">
        <div className="xb-footer">
          <div className="row">
            <div className="col-lg-4 col-md-6 align-items-center ">
              <div className="footer-widget">
                <span className="xb-item--sub-title"> Quick Links</span>
                <ul className="xb-item--holder list-unstyled">
                  <li className="xb-item--list">
                    <NavLink onClick={ClickHandler} to="/moneytransfer" className="hover-yellow">
                      Money Transfer
                    </NavLink>
                  </li>
                  <li className="xb-item--list">
                    <NavLink onClick={ClickHandler} to="/about" className="hover-yellow">
                      About Us
                    </NavLink>
                  </li>
                  <li className="xb-item--list">
                    <NavLink onClick={ClickHandler} to="/contact" className="hover-yellow">
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 align-items-center ">
              <div className="footer-widget footer-nees-helf">
                <span className="xb-item--sub-title">Help & Support</span>
                <ul className="xb-item--holder list-unstyled">
                  {/* <li className="xb-item--number footer-list">
                    <a href="tel:+447459852485" className="hover-yellow">
                      <span>
                        <img src={icon1} alt="" />
                      </span>
                      +44 745 985 2485
                    </a>
                  </li> */}
                  <li className="xb-item--number footer-list ">
                    <a
                      href="https://wa.me/447459852485?text=Hello%20I%20want%20to%20know%20more%20about%20your%20money%20transfer%20services"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover-yellow"
                    >
                      <span>
                        <img src={iconwp} alt="" />
                      </span>
                      +44 745 985 2485
                    </a>

                  </li>
                  <li className="xb-item--email">
                    <span>
                      <img src={icon2} alt="" />
                    </span>{" "}
                    <a
                      style={{ color: "#f6f0e6e6" }}
                      href="mailto:info@bugamoney.com"
                      className="hover-yellow"
                    >
                      info@bugamoney.com
                    </a>
                  </li>
                  <li className="xb-item--list"></li>
                </ul>

                {/* <ul className="xb-item--social-link list-unstyled ul_li mt-45">
                  <li className="xb-item--social-icon">
                    <Link onClick={ClickHandler} to="/">
                      <i className="fab fa-facebook-f"></i>
                    </Link>
                  </li>
                  <li className="xb-item--social-icon">
                    <Link
                      onClick={ClickHandler}
                      to="/contact"
                      aria-label="Twitter"
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.3872 0H15.9952L10.299 7.20048L17 17H11.7545L7.64298 11.0582L2.94415 17H0.332464L6.42395 9.29688L0 0H5.37853L9.09105 5.43101L13.3872 0ZM12.4711 15.2755H13.9155L4.5917 1.63462H3.0402L12.4711 15.2755Z"
                          fill="#ffffff"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li className="xb-item--social-icon">
                    <Link onClick={ClickHandler} to="/">
                      <i className="fab fa-linkedin-in"></i>
                    </Link>
                  </li>
                 
                </ul> */}
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="sa-newslatter footer-widget">
                <span className="xb-item--sub-title">Download App</span>
                <div className="xb-item--apps ul_li">
                  <div className="xb-item--app">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.org.bugamoney"
                      onClick={ClickHandler}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={icon3} alt="" />
                    </a>
                  </div>
                  <div className="xb-item--app">
                    <a
                      href="https://apps.apple.com/in/app/buga-money-transfer/id6749626385"
                      onClick={ClickHandler}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={icon4} alt="" />
                    </a>
                  </div>
                </div>
                {/* <div className="xb-item--input-box">
                  <label htmlFor="text6">📩 Subscribe for Updates</label>
                  <form className="xb-item--input_field pos-rel" onSubmit={SubmitHandler}>
                    <input type="email" name="gmail" id="text6" placeholder="Enter your email" />
                    <button type="submit" className="xb-item--btn"><i className="fas fa-paper-plane"></i></button>
                  </form>
                </div> */}
              </div>
            </div>
            <div className="footer-copyright ul_li_between">
              <p className="copyright mt-20 text-center">
                Buga Money is the trading name of Peniel Services Limited, registered with the Financial Conduct Authority (FCA) in the UK with FRN 628917. Registered with Companies House with registration number 05689465.
              </p>
            </div>
          </div>

          <div className="footer-copyright ul_li_between">
            <p className="copyright mt-20">
              Copyright © {new Date().getFullYear()}{" "}
              <Link onClick={ClickHandler} to="/" className="hover-yellow">
                Buga Money
              </Link>
              . Developed by
              <a
                href="https://www.calyx-solutions.com/"
                target="_blank"
                className="hover-yellow"
              >
                {" "}
                Calyx Solutions.
              </a>
            </p>
            <ul className="hds-footer-links ul_li mt-20">
              <li>
                <NavLink onClick={ClickHandler} to="/terms-condition" className="hover-yellow">
                  Terms & Conditions
                </NavLink>
              </li>
              <li>
                <NavLink onClick={ClickHandler} to="/privacy-policy" className="hover-yellow">
                  Privacy Policy
                </NavLink>
              </li>
              <li>
                <NavLink onClick={ClickHandler} to="/complaint-policy" className="hover-yellow">
                  Complaints Policy
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
